import "./index.scss";

export const ErrorMessage = ({ error }) => {
  if (!error) return null;
  return <p className="error-message">{error.message}</p>;
};
